<template>
  <div>
    <b-modal
      v-model="isModalMoveToStationed"
      :hide-footer="true"
      :hide-header="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <form @submit.prevent="submitReasonToStationed">
        <b-row>
          <b-col>
            <h5>Why are you stationing "{{ titleFocus }}" Journey?</h5>
            <div class="d-flex">
              <b-form-radio
                v-model="reasonToStationed"
                :value="{ uid: 0, text: 'I do not have enough money' }"
                id="noMoney"
                name="reason"
              />
              <label for="noMoney">I do not have enough money</label>
            </div>
            <div class="d-flex">
              <b-form-radio
                v-model="reasonToStationed"
                :value="{ uid: 1, text: 'I do not have time' }"
                id="noTime"
                name="reason"
              />
              <label for="noTime">I do not have time</label>
            </div>
            <div class="d-flex">
              <b-form-radio
                v-model="reasonToStationed"
                :value="{ uid: 2, text: 'I am not interested anymore' }"
                id="noInterest"
                name="reason"
              />
              <label for="noInterest">I am not interested anymore</label>
            </div>
            <div class="d-flex">
              <b-form-radio
                v-model="reasonToStationed"
                :value="{ uid: null, text: null }"
                id="other"
                name="reason"
              />
              <label for="other">Other reason:</label>
            </div>
            <div>
              <b-textarea
                name="newReason"
                @change="onChangeOtherReason"
                :disabled="
                  (reasonToStationed && reasonToStationed.uid !== null) ||
                    !reasonToStationed
                "
              />
            </div>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end">
          <b-button
            class="mt-4 mr-2"
            @click="submitReasonToStationed('cancel')"
          >
            Cancel
          </b-button>
          <b-button class="mt-4" type="submit" :disabled="!reasonToStationed">
            Station
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal
      v-model="isModalMoveToOnTrack"
      :hide-header="true"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <b-container style="position: relative">
        <b-row>
          <h2>Let's Activate</h2>
        </b-row>
        <b-row>
          <p>
            Enter email addresses in order to invite your
            {{ "<" + "C" + ">" }}rew to join “{{
              itemToMoveDetail ? itemToMoveDetail.destination.text1 : ""
            }}” journey.
          </p>
          <p>
            When they accept, they will be able to track your progress towards
            your 三Destination.
          </p>
        </b-row>
      </b-container>
      <form @submit.prevent="submitActivate">
        <b-container>
          <div v-if="itemToMoveDetail">
            <b-row
              v-for="(el, index) in itemToMoveDetail.crew
                .filter(el => !el._connected_at)
                .filter(el => !el._deleted_at)"
              :key="index"
              class="mb-2"
            >
              <!-- <div > -->
              <b-col cols="4" class="d-flex pl-0">
                <b-col cols="3" class="px-0 mr-2">
                  <crew-icon
                    :name="el.text"
                    :pp="
                      isTryToConnect[index] &&
                        isUsersOnDb[index] &&
                        isUsersOnDb[index].imgURL &&
                        isUsersOnDb[index].imgURL
                    "
                  />
                </b-col>
                <b-col
                  cols="9"
                  style="display: flex;flex-direction: column;justify-content: center;"
                >
                  <b-row>
                    <b-col>
                      <b>{{ el && el.text }}</b>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="font-size: small">
                      {{ el && el.subText }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" style="font-size: small">
                      <b-link
                        @click="handleStandardBtnClick(index)"
                        :active="
                          virtualState[index] === 'standard' ? true : false
                        "
                      >
                        Standard </b-link
                      >|
                      <b-link
                        variant="success"
                        @click="handleSidecarBtn(index)"
                        :active="
                          virtualState[index] === 'sidecar' ? true : false
                        "
                        v-b-tooltip="
                          `Select if two or more will work equally on this journey`
                        "
                      >
                        Sidecar </b-link
                      >|
                      <b-link
                        variant="success"
                        @click="handleVirtualBtn(index)"
                        :active="
                          virtualState[index] === 'virtual' ? true : false
                        "
                        v-b-tooltip="
                          `Select if this member is part of your imaginary counsel`
                        "
                      >
                        Virtual
                      </b-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
              <b-col cols="5" class="d-flex align-items-center">
                <b-input
                  v-model="activateEmailList[index]"
                  placeholder="email here..."
                  :disabled="
                    virtualState[index] === 'virtual' || isTryToConnect[index]
                  "
                />
                <!-- !isUsersOnDb[index] || -->
              </b-col>
              <b-col
                cols="3"
                class="d-flex align-items-center"
                v-if="virtualState[index] !== 'virtual'"
              >
                <b-button
                  variant="outline-warning"
                  @click="
                    isTryToConnect[index]
                      ? handleUnjoinBtn(el, index)
                      : handleJoinBtn(el, index)
                  "
                >
                  <!-- JOIN -->
                  {{ isTryToConnect[index] ? "UNJOIN" : "INVITE TO JOIN" }}
                  <!-- {{ isUsersOnDb[index] ? "JOIN" : "UNJOIN" }} -->
                </b-button>
              </b-col>
              <!-- <b-col cols=3 class="d-flex justify-content-end align-items-center">
                      <b-button variant="success" @click="handleSidecarBtn(index)">
                        sidecar
                      </b-button>
                      |
                      <b-button variant="success" @click="handleVirtualBtn(index)">
                        virtual
                      </b-button>
                    </b-col> -->
              <!-- <b-col class="d-flex align-items-center">
                      <b-button variant="success">
                        Invite to Join
                      </b-button>
                    </b-col> -->
              <!-- </div> -->
            </b-row>
          </div>
          <b-button variant="primary" class="w-100 mt-4" type="submit">
            Activate!!!
          </b-button>
          <div
            @click="submitActivate('cancel')"
            style="position: absolute; right: 10px; top: 10px; font-size: 20px; cursor: pointer"
          >
            x
          </div>
        </b-container>
      </form>
    </b-modal>
    <b-modal
      v-model="isModalJoin"
      ok-title="Yes"
      cancel-title="No"
      @ok="handleOkModalJoin"
      @cancel="handleCancelModalJoin"
    >
      <b-container>
        <b-row>
          Would you like to connect this user with:
        </b-row>
        <b-row>
          <b-col cols="2">
            <crew-icon
              :pp="
                isUsersOnDb[indexModalUsersOnDb] &&
                  isUsersOnDb[indexModalUsersOnDb].imgURL
              "
              :name="
                isUsersOnDb[indexModalUsersOnDb] &&
                  isUsersOnDb[indexModalUsersOnDb].firstname &&
                  isUsersOnDb[indexModalUsersOnDb].lastname &&
                  isUsersOnDb[indexModalUsersOnDb].firstname +
                    ' ' +
                    isUsersOnDb[indexModalUsersOnDb].lastname
              "
            />
          </b-col>
          <b-col>
            {{
              isUsersOnDb[indexModalUsersOnDb] &&
                isUsersOnDb[indexModalUsersOnDb].firstname &&
                isUsersOnDb[indexModalUsersOnDb].lastname &&
                isUsersOnDb[indexModalUsersOnDb].firstname +
                  " " +
                  isUsersOnDb[indexModalUsersOnDb].lastname
            }}
          </b-col>
        </b-row>
        <b-row>
          as
          {{
            itemToMoveDetail &&
              itemToMoveDetail.crew &&
              itemToMoveDetail.crew.filter(el => !el._connected_at)[
                indexModalUsersOnDb
              ] &&
              itemToMoveDetail.crew.filter(el => !el._connected_at)[
                indexModalUsersOnDb
              ].text
          }}
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import crewIcon from "../../crewIcon";

export default {
  name: "jab-tracks",
  components: {
    crewIcon
  },
  props: {
    modalTrack: {
      type: Boolean
    },
    modalStationed: {
      type: Boolean
    },
    virtualStateParent: {
      type: Array
    },
    isTryToConnect: {
      type: Array
    },
    activateEmailListParent: {
      type: Array
    },
    isUsersOnDb: {
      type: Array
    },
    itemToMoveDetail: {
      type: Object
    },
    itemToMoveParent: {
      type: Object
    },
    itemToMoveId: {
      type: String
    }
  },
  methods: {
    getTitle() {
      return this.itemToMove
        ? this.itemToMove.item.innerText.slice(
            0,
            this.itemToMove.item.innerText.indexOf(" so that ")
          )
        : null;
    },
    submitReasonToStationed(type) {
      console.log("itemToMove -->", this.itemToMove);
      let temp = { ...this.itemToMove };
      if (type === "cancel") {
        // this.$store.dispatch("user/updateFocuses", {
        //   focusId: this.itemToMoveId,
        //   state: temp.from.id
        // });
        this.itemToMove = null;
        this.isModalMoveToStationed = false;
        this.reasonToStationed = null;
      } else {
        this.$store
          .dispatch("user/addStationReason", { reason: this.reasonToStationed })
          .then(reason => {
            this.$store.dispatch("user/updateFocuses", {
              focusId: this.itemToMoveId,
              state: temp.to.id,
              reason_stationed: reason
            });
            this.itemToMove = null;
            this.isModalMoveToStationed = false;
            this.reasonToStationed = null;
          });
      }
    },
    submitActivate(type) {
      console.log("submitActivate itemToMove -->", this.itemToMove);
      let temp = { ...this.itemToMove };
      if (type === "cancel") {
        // this.$store.dispatch("user/updateFocuses", {
        //   focusId: this.itemToMoveId,
        //   state: temp.from.id
        // });
        this.itemToMove = null;
        this.isModalMoveToOnTrack = false;
        // this.reasonToStationed = null
      } else {
        // console.log(this.itemToMoveDetail, "ini detailnyaah")

        // SAVE IN _EVENTS

        // if(!this.itemToMoveDetail._duration) {
        // this.$store.dispatch('user/updateFocuses', {_duration: "6 Weeks", focusId: this.itemToMoveId})
        // }

        this.saveEventInList();

        this.$store.dispatch("user/updateFocuses", {
          focusId: this.itemToMoveId,
          state: temp.to.id
        });
        if (
          this.itemToMoveDetail.crew.filter((el, i) => !el._connected_at).length
        ) {
          let emailList = this.activateEmailList.map((el, index) => {
            return {
              to: this.activateEmailList[index],
              subject: `You have invited to share a journey~`,
              text: `Hey ${
                this.itemToMoveDetail.crew.filter((el, i) => !el._connected_at)[
                  index
                ].text
              }, you have invited to share a journey in JourneyBinder!`
            };
          });
          let emailDetails = emailList.filter(
            (el, index) =>
              this.virtualState[index] !== "virtual" &&
              this.isTryToConnect[index]
          );
          let crewDetails = this.isUsersOnDb.filter(
            (el, index) =>
              this.virtualState[index] !== "virtual" &&
              this.isTryToConnect[index]
          );
          let listEmail = this.activateEmailList.filter(
            (el, index) =>
              this.virtualState[index] !== "virtual" &&
              this.isTryToConnect[index]
          );
          this.$store.dispatch("user/sendEmail", { emailDetails });
          crewDetails.forEach(el => {
            this.$store.dispatch("user/sendNotification", {
              userTo: el && el.uid,
              payload: {
                focus: {
                  uid: this.itemToMoveId,
                  destination: this.itemToMoveDetail.destination
                }
              },
              typeId: "invitation"
            });
          });
          this.$store.dispatch("user/activateFocus", {
            listEmail: this.activateEmailList,
            crewDetails: this.isUsersOnDb,
            focusId: this.itemToMoveId,
            virtualState: this.virtualState
          });
          this.$store.dispatch("user/addStatesFocusesNotif", {
            crewDetails,
            listEmail,
            focusId: this.itemToMoveId
          });
        }

        // this.$store.dispatch('user/saveEventInLists', {focus: this.itemToMoveDetail, focusId: this.itemToMoveId})

        this.itemToMove = null;
        this.isModalMoveToOnTrack = false;
      }
    },
    saveEventInList() {
      if (!this.itemToMoveDetail._duration) {
        this.$store.dispatch("user/updateFocuses", {
          _duration: "6 Weeks",
          focusId: this.itemToMoveId
        });
      }
      this.$store.dispatch("user/saveEventInLists", {
        focus: this.itemToMoveDetail,
        focusId: this.itemToMoveId
      });
    },
    onChangeOtherReason(e) {
      this.reasonToStationed.text = e;
    },
    handleStandardBtnClick(index) {
      this.virtualState = this.virtualState.map((el, i) => {
        if (i === index) {
          return "standard";
        }
        return el;
      });
    },
    handleSidecarBtn(index) {
      this.virtualState = this.virtualState.map((el, i) => {
        if (i === index) {
          return "sidecar";
        }
        return el;
      });
    },
    handleVirtualBtn(index) {
      this.virtualState = this.virtualState.map((el, i) => {
        if (i === index) {
          this.activateEmailList = this.activateEmailList.map((ele, ind) => {
            if (i === ind) {
              return "";
            }
            return ele;
          });
          return "virtual";
        }
        return el;
      });
    },
    handleJoinBtn(el, index) {
      this.$store
        .dispatch("user/findingAUserByEmail", {
          email: this.activateEmailList[index]
        })
        .then(data => {
          if (data) {
            this.isUsersOnDb = this.isUsersOnDb.map((el, i) => {
              if (i === index) {
                this.indexModalUsersOnDb = i;
                this.isModalJoin = true;
                return data;
              }
              return el;
            });
          } else {
            this.isUsersOnDb = this.isUsersOnDb.map((el, i) => {
              if (i === index) {
                this.isTryToConnect = this.isTryToConnect.map((el, ind) => {
                  if (index === ind) {
                    return true;
                  }
                  return el;
                });
                return null;
              }
              return el;
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleUnjoinBtn(el, index) {
      // this.isTryToConnect[index] = false
      this.isTryToConnect = this.isTryToConnect.map((el, i) => {
        if (index === i) {
          return false;
        }
        return el;
      });
    },
    handleOkModalJoin() {
      this.isModalJoin = false;
      this.isTryToConnect = this.isTryToConnect.map((el, index) => {
        if (index === this.indexModalUsersOnDb) {
          return true;
        }
        return el;
      });
    },
    handleCancelModalJoin() {
      this.isUsersOnDb.map((el, i) => {
        if (i === this.indexModalUsersOnDb) {
          return null;
        }
        return el;
      });
      this.isModalJoin = false;
      // [indexModalUsersOnDb]
    }
  },
  computed: {
    isModalMoveToOnTrack: {
      get() {
        console.log("isModalMoveToOnTrack", this.modalTrack);
        return this.modalTrack;
      },
      set() {
        this.$emit("modal:reason-track-close");
      }
    },
    isModalMoveToStationed: {
      get() {
        console.log("isModalMoveToStationed", this.modalStationed);
        return this.modalStationed;
      },
      set() {
        this.$emit("modal:reason-stationed-close");
      }
    },
    titleFocus: {
      get() {
        return this.itemToMove
          ? this.itemToMove.item.innerText.slice(
              0,
              this.itemToMove.item.innerText.indexOf(" so that ")
            )
          : null;
      }
    },
    itemToMove: {
      get() {
        console.log("get move item", this.itemToMoveParent);
        return this.itemToMoveParent;
      },
      set(val) {
        this.$emit("update:itemToMove", val);
      }
    },
    activateEmailList: {
      get() {
        console.log("get move item", this.activateEmailListParent);
        return this.activateEmailListParent;
      },
      set(val) {
        this.$emit("update:activateEmailList", val);
      }
    },
    virtualState: {
      get() {
        console.log("get move item", this.virtualStateParent);
        return this.virtualStateParent;
      },
      set(val) {
        this.$emit("update:virtualState", val);
      }
    }
  },
  data() {
    return {
      reasonToStationed: null,
      indexModalUsersOnDb: -1,
      isModalJoin: false
    };
  }
};
</script>
